import { Flex } from "@chakra-ui/react";
import PublicLayout from "../../public/Layout/layout";
import LoginForm from "./LoginForm";
const Login = (props) => {
  return (
    <PublicLayout color="main_1" bg="white" register={true}>
      <Flex
        bg="whiteAlpha.700"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        mt="150px"
        w="100%"
        h="100%"
      >
        <div style={{ width: "40%" }}>
          <LoginForm />
        </div>
      </Flex>
    </PublicLayout>
  );
};

export default Login;
